// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"705":"bd25187b","808":"407c84e9"}[chunkId] + ".css";
};